module.exports = __webpack_public_path__ + "static/img/1-2.2b3c4cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/1-2.png
// module id = TDUl
// module chunks = 0